import GoogleMap from '../modules/google_map'

up.compiler('[map]', (element, data) => {

  let googleMap = undefined

  const apiKey = data.apiKey
  const location = data.location
  const mapData = data.mapData

  const mapElement = up.element.createFromHTML('<div class="map-content" />')
  element.appendChild(mapElement)

  new GoogleMap(mapElement, apiKey, location, mapData).then((instance) => {
    element.mapInstance = instance // for tests
    googleMap = instance
  })

  element.addEventListener('app:map:focusPin', (event) => {
    googleMap.focusPin(event.pinId)
  })

  element.addEventListener('app:map:dataChanged', (event) => {
    googleMap.changeMapData(event.mapData)
  })

});
